module.exports = __webpack_public_path__ + "static/media/micro-game.11c1a51c.png";